import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  launchFast(event) {
    event.preventDefault()

    document.dispatchEvent(new CustomEvent('openFast'))
  }

  launchLoginSignupModal(event) {
    event.preventDefault()

    document.dispatchEvent(
      new CustomEvent('open-login-signup-modal', {
        detail: {
          target: event.target
        }
      })
    )
  }
}
